import { Navigate, useLocation } from "react-router-dom";

function RedirectWithSearch({ to }) {
    const location = useLocation();

    return (
        <Navigate
            to={{
                pathname: to,
                search: location.search,
                hash: location.hash,
            }}
            replace
        />
    );
}

export { RedirectWithSearch}